export default __webpack_public_path__ + "static/media/Microsoft-Logo-Hover.aee52bbf.svg";